(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-marinezoom"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mz-hero-slideshow')) {
  customElements.define('mz-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.mz-slideshow__slide'));
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.index = 0;
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelector('.mz-slideshow__controls').hidden = false;
      this.classList.add('is-ready');
      this.show(0);
      this.querySelector('[data-prev]').addEventListener('click', () => { this.show(this.index - 1); this.schedule(); }, options);
      this.querySelector('[data-next]').addEventListener('click', () => { this.show(this.index + 1); this.schedule(); }, options);
      this.querySelector('[data-toggle]').addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, options);
      this.addEventListener('mouseenter', () => clearInterval(this.timer), options);
      this.addEventListener('mouseleave', () => this.schedule(), options);
      this.addEventListener('focusin', () => clearInterval(this.timer), options);
      this.addEventListener('focusout', () => setTimeout(() => this.schedule(), 0), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) { this.paused = true; this.show(index); this.schedule(); }
      }, options);
      this.schedule();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === this.index); slide.setAttribute('aria-hidden', String(i !== this.index)); });
      this.querySelector('[data-counter]').textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    schedule() {
      clearInterval(this.timer);
      this.querySelector('[data-toggle]').textContent = this.paused ? this.dataset.play : this.dataset.pause;
      if (!this.paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.timer = setInterval(() => this.show(this.index + 1), 5000);
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
